function SvgBaby({ color = "#1A1A1C", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#svg_baby_icon_2)">
        <path
          d="M10.001 1.66797C14.5843 1.66797 18.334 5.41764 18.334 10.001C18.334 14.5843 14.5843 18.334 10.001 18.334C5.41764 18.334 1.66797 14.5843 1.66797 10.001C1.66797 5.41764 5.41764 1.66797 10.001 1.66797ZM11.084 6.16797C9.75071 7.33443 8.08383 7.91797 6.33398 7.91797C5.33415 7.91793 4.3345 7.75056 3.41797 7.33398C3.08464 8.16732 2.91797 9.08431 2.91797 10.001C2.91797 13.9176 6.08431 17.084 10.001 17.084C13.9176 17.084 17.084 13.9176 17.084 10.001C17.084 9.25098 17.001 8.50065 16.751 7.83398C16.501 7.91732 16.1673 7.91797 15.834 7.91797C14.0841 7.91789 12.4172 7.25123 11.084 6.16797ZM12.916 13.751C12.1661 14.5841 11.0831 15.0009 10 15.001C8.91669 15.001 7.83333 14.584 7 13.834L7.91602 12.918C8.99936 14.0013 11 14.0006 12 12.834L12.916 13.751ZM7.16895 9.16797C7.62918 9.16797 8.00195 9.54074 8.00195 10.001C8.00195 10.4612 7.62918 10.834 7.16895 10.834C6.70871 10.834 6.33594 10.4612 6.33594 10.001C6.33594 9.54074 6.70871 9.16797 7.16895 9.16797ZM12.918 9.16797C13.3781 9.16814 13.751 9.54085 13.751 10.001C13.751 10.4611 13.3781 10.8338 12.918 10.834C12.4577 10.834 12.084 10.4612 12.084 10.001C12.084 9.54074 12.4577 9.16797 12.918 9.16797ZM10.001 2.91797C7.50098 2.91797 5.33431 4.2513 4.00098 6.16797C4.75084 6.50122 5.50083 6.66793 6.33398 6.66797C8.00065 6.66797 9.5013 6.08464 10.668 4.91797C10.918 4.66797 11.334 4.66797 11.584 4.91797C12.6672 6.00123 14.2508 6.66788 15.834 6.66797H16.251C15.001 4.41797 12.6676 2.91797 10.001 2.91797Z"
          fill={color || color}
        />
      </g>
      <defs>
        <clipPath id="svg_baby_icon_2">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBaby;
